export function errorModal(err) {
  this.$store.dispatch("serverError", err.response)
  this.$bvModal.show("report-error-modal")  
}

